import { GetDamagedTypeQueryParamsType } from '@/common/queries/getDamagedType/getDamagedTypeQuery.type';
import { getDamagedType } from '@/common/queries/getDamagedType/getDamagedTypeQueryFunction';
import { queryOptions } from '@tanstack/react-query';

const getDamagedTypeQueryOption = (params: GetDamagedTypeQueryParamsType) => {
  const { enabled = true } = params;
  return queryOptions({
    queryKey: ['getDamagedType', params],
    queryFn: () => getDamagedType(params),
    enabled: enabled,
    select: (data) => data[0],
    meta: { onSuccess: params.onSuccess },
  });
};

export default getDamagedTypeQueryOption;
